const style = {
    fieldContainer: {marginBottom: 3},
    label: {margin: '0 0 3px'},
    inputField: {
        borderRadius: '4px',
    },
};

export default style;
